/**
 * Reusable warning banners for backup/restore dialogs.
 */

import { AlertTriangle, HardDrive, AlertCircle } from 'lucide-react';

/**
 * Warning about server-side file location (for both backup and restore).
 */
export function ServerSideWarning() {
  return (
    <div className="flex items-start gap-3 p-3 rounded-md bg-amber-50 border border-amber-200 dark:bg-amber-950 dark:border-amber-800">
      <AlertTriangle className="h-4 w-4 text-warning shrink-0 mt-0.5" />
      <div className="flex items-start gap-2 text-sm text-amber-800 dark:text-amber-200">
        <HardDrive className="h-4 w-4 shrink-0 mt-0.5" />
        <span>
          The backup file must be located <strong>on the SQL Server machine</strong>, not
          your local computer. Ensure the SQL Server service account has the necessary permissions.
        </span>
      </div>
    </div>
  );
}

/**
 * Warning about destructive operations (for restore).
 */
export function DestructiveWarning({ testId }: { testId?: string }) {
  return (
    <div
      className="flex items-start gap-3 p-3 rounded-md bg-red-50 border border-red-200 dark:bg-red-950 dark:border-red-800"
      data-testid={testId}
    >
      <AlertCircle className="h-4 w-4 text-red-600 dark:text-red-400 shrink-0 mt-0.5" />
      <div className="text-sm text-red-800 dark:text-red-200">
        <strong>Warning:</strong> Restoring a database is a destructive operation. If the
        target database exists and you enable overwrite, <strong>all existing data will be
        permanently lost</strong>.
      </div>
    </div>
  );
}
